import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import ChangePasswordLayer from '../components/ChangePasswordLayer';

const ChangePasswordPage = () => {
  return (
    <MasterLayout>
      <ChangePasswordLayer />
    </MasterLayout>
  );
};

export default ChangePasswordPage;
